module.exports = __webpack_public_path__ + "img/qita1.827acfcf.png";